import * as React from 'react'

import { Box } from '@factorialco/deprecated-design-system'
import { compact, uniq } from 'lodash'

import i18n from 'modules/core/lib/i18n'

import type BlockedPeriod from 'modules/timeoff/store/models/BlockedPeriods/BlockedPeriod'
import type Leave from 'modules/timeoff/store/models/Leave'
import type LeaveType from 'modules/timeoff/store/models/LeaveType'

import LegendItem from './LegendItem'

interface Props {
  employeeLeaves: Leave[]
  blockedPeriods: BlockedPeriod[]
}

const Legend = ({ employeeLeaves, blockedPeriods }: Props) => {
  const leaveTypes = compact(uniq(employeeLeaves.map((leave) => leave.leaveType)))

  const blockedPeriodLabel = blockedPeriods
    ? `${i18n.tp('time_off.blocked_period.label', {
        count: blockedPeriods.length,
      })}`
    : ''

  return (
    <Box flexDirection="row" alignItems="center" flexWrap="wrap">
      <LegendItem label={i18n.t('time_off.today')} type="viridian" outline />
      {leaveTypes.map(
        (leaveType: LeaveType, index: number) =>
          leaveType.name && (
            <LegendItem key={index} label={leaveType.name} color={leaveType.attributes.color} />
          )
      )}
      {blockedPeriods && blockedPeriods.length >= 1 && (
        <LegendItem label={blockedPeriodLabel} color={blockedPeriods[0]?.periodColor} />
      )}
    </Box>
  )
}

export default Legend
